import React, { useState, useEffect } from 'react';
import './PrivacyPolicy.scss';

const PrivacyPolicy = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.pageYOffset > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="privacy-policy">
      <header className="header">
        <div className="container header-content">
          <div className="logo">
            <div className="logo-icon">f</div>
            <div className="logo-text">Politique de Confidentialité</div>
          </div>
        </div>
      </header>

      <nav className="navigation">
        <div className="container nav-container">
          <ul className="nav-links">
            <li><a href="#home" className="active">Accueil</a></li>
            <li><a href="#data">Données collectées</a></li>
            <li><a href="#usage">Utilisation</a></li>
            <li><a href="#sharing">Partage</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>
      </nav>

      <main className="container main-content">
        <div className="privacy-content">
          <h1>Politique de Confidentialité - Connexion via Facebook</h1>
          
          <p>Dernière mise à jour: 10 novembre 2023</p>
          
          <p>Cette politique de confidentialité décrit comment notre application ("nous", "notre", "nos") collecte, utilise et partage vos informations personnelles lorsque vous utilisez notre service de connexion via Facebook.</p>
          
          <div className="highlight">
            <p>En utilisant notre application et en vous connectant via Facebook, vous acceptez les pratiques décrites dans cette politique de confidentialité.</p>
          </div>
          
          <h2>1. Informations que nous collectons</h2>
          <p>Lorsque vous vous connectez à notre application via Facebook, nous pouvons collecter les informations suivantes avec votre consentement :</p>
          <ul>
            <li>Votre nom et prénom</li>
            <li>Votre adresse e-mail</li>
            <li>Votre photo de profil</li>
            <li>Votre ID Facebook unique</li>
            <li>Autres informations de profil publiques (selon vos paramètres de confidentialité Facebook)</li>
          </ul>
          
          <h2>2. Utilisation des informations</h2>
          <p>Nous utilisons les informations collectées pour les finalités suivantes :</p>
          <ul>
            <li>Créer et gérer votre compte utilisateur</li>
            <li>Personnaliser votre expérience utilisateur</li>
            <li>Vous fournir les services demandés</li>
            <li>Vous envoyer des communications importantes concernant votre compte</li>
            <li>Améliorer nos services et développer de nouvelles fonctionnalités</li>
          </ul>
          
          <h2>3. Partage des informations</h2>
          <p>Nous ne vendons, ne louons ni ne partageons vos informations personnelles avec des tiers sans votre consentement explicite, sauf dans les cas suivants :</p>
          <ul>
            <li>Avec des prestataires de services qui nous aident à exploiter notre application (sous stricte obligation de confidentialité)</li>
            <li>Pour se conformer à des obligations légales ou à une demande gouvernementale</li>
            <li>Pour protéger nos droits, la propriété intellectuelle ou la sécurité de nos utilisateurs</li>
            <li>Dans le cadre d'une fusion, acquisition ou vente de tout ou partie de nos actifs</li>
          </ul>
          
          <h2>4. Conservation des données</h2>
          <p>Nous conservons vos informations personnelles aussi longtemps que nécessaire pour fournir nos services, respecter nos obligations légales, résoudre les litiges et faire respecter nos accords.</p>
          
          <h2>5. Vos droits</h2>
          <p>Vous avez le droit de :</p>
          <ul>
            <li>Accéder aux informations que nous détenons sur vous</li>
            <li>Demander la correction de données inexactes</li>
            <li>Demander la suppression de vos données personnelles</li>
            <li>Vous opposer au traitement de vos données</li>
            <li>Demander la portabilité de vos données</li>
            <li>Retirer votre consentement à tout moment</li>
          </ul>
          
          <h2>6. Sécurité des données</h2>
          <p>Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos informations personnelles contre tout accès non autorisé, modification, divulgation ou destruction.</p>
          
          <h2>7. Modifications de cette politique</h2>
          <p>Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Les modifications seront publiées sur cette page avec une date de révision mise à jour.</p>
          
          <h2>8. Nous contacter</h2>
          <p>Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits, veuillez nous contacter à :</p>
          <ul>
            <li>Email: privacy@example.com</li>
            <li>Adresse: 123 Rue de la Privacy, Paris, France</li>
          </ul>
        </div>
      </main>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Notre application</h3>
              <ul className="footer-links">
                <li><a href="#">À propos de nous</a></li>
                <li><a href="#">Fonctionnalités</a></li>
                <li><a href="#">Tarifs</a></li>
                <li><a href="#">Blog</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h3>Légal</h3>
              <ul className="footer-links">
                <li><a href="#">Politique de confidentialité</a></li>
                <li><a href="#">Conditions d'utilisation</a></li>
                <li><a href="#">Politique des cookies</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h3>Support</h3>
              <ul className="footer-links">
                <li><a href="#">Centre d'aide</a></li>
                <li><a href="#">Contact</a></li>
                <li><a href="#">FAQ</a></li>
              </ul>
            </div>
          </div>
          
          <div className="copyright">
            <p>&copy; 2023 Notre Application. Tous droits réservés.</p>
          </div>
        </div>
      </footer>

      <a 
        href="#" 
        className={`back-to-top ${showBackToTop ? 'show' : ''}`}
        onClick={scrollToTop}
      >
        ↑
      </a>
    </div>
  );
};

export default PrivacyPolicy;